<template>
    <modal :partners="true" @close="$emit('close')" class="listing">
        <div class="flex relative flex-col text-center w-full  p-8 text-main-text" v-if="getAllEvents.length">
            <button class="absolute pin-t pin-r outline-none m-8 pr-2 z-40" @click="$emit('close')">
                <!--<font-awesome-icon class="text-grey-dark text-2xl" :icon="['fas', 'times']"></font-awesome-icon>-->
                <img class="" src="@/assets/SVG/cross-partners.svg"/>
            </button>
            <h3 class="">Куда перенести команду?</h3>
            <div class="pr-6 pb-6">
                <button v-for="datePlace in getAllEvents" :key="datePlace.uuid" @click="postNewEventDate(datePlace.uuid)" class=" text-left bg-white outline-none rounded-lg w-full text-grey-darkest border border-grey-darkest hover:border-brand-light hover:bg-brand-light hover:text-white ml-4 text-base font-semibold p-5 mt-6 -mb-4">
                    {{getEventDate(datePlace.played_at)[0]}}&nbsp;/&nbsp;{{datePlace.place}}
                </button>
            </div>
        </div>
        <div class="flex relative flex-col text-center w-full  p-8 text-main-text" v-else>
            <button class="absolute pin-t pin-r outline-none m-8 pr-2 z-40" @click="$emit('close')">
                <!--<font-awesome-icon class="text-grey-dark text-2xl" :icon="['fas', 'times']"></font-awesome-icon>-->
                <img class="" src="@/assets/SVG/cross-partners.svg"/>
            </button>
            <h3 class="">Нету дат для переноса заявки.</h3>
            <p class="mt-6">Перенос заявок возможен только в пределах <br> одной серии игр!</p>

        </div>

    </modal>
</template>

<script>
import client from '@/clients/partners';
import Modal from '@/views/modals/base-modal';
import format from 'date-fns/format';
import ru from 'date-fns/locale/ru';


export default {
  name: 'changeDateModal',
  props: ['uuid', 'active_ids', 'record_id'],
  components: { Modal },
  created() {
    this.getEvents();
  },
  data() {
    return {
      events: [],

    };
  },
  computed: {
    getAllEvents() {
      const eventDates = [];
      for (const i in this.events) {
        for (const j in this.events[i]) {
          eventDates.push(this.events[i][j]);
        }
      }
      return eventDates.filter(item => item.event_record_id === this.record_id && item.uuid !== this.uuid && item.status != 'waiting_statistics');
    },
  },
  methods: {
    getEvents() {
      client.get('/event-dates')
        .then((response) => {
          this.events = response.data;
        });
    },
    postNewEventDate(id) {
      client.patch(`applications/dates/${this.uuid}/change`, {
        applications_ids: [...this.active_ids],
        event_day_id: id,
      }).then(() => {
        this.$emit('change', { uuid: id });
      }).catch((error) => {
        this.$emit('error_change');
      });
    },
    getEventDate(date) {
      const dates = [];
      dates.push(format(date, 'DD MMMM, dd', { locale: ru }));
      return dates;
    },
  },
  beforeDestroy() {
    document.body.style.overflow = '';
  },
};
</script>

<style scoped>
.listing {
  max-height: 80% !important;
}
.upper {
  z-index: 555;
}
</style>
